import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { CustomCol, FrameItem } from "./../QrFrameItems";
import useWindowSize from "../../../../../hooks/useWindowSize";
import PreMadeFrameItem from "./PreMadeFrameItem";
import { useDispatch, useSelector } from "react-redux";
import NoTemplateBtn from "./NoTemplateBtn";
import {
  setFramesModalCategory,
  setIsFramesModal,
} from "../../../../../redux/slices/modals";
import { setActivePremadeTemplateId } from "../../../../../redux/slices/preMadeTemplates";
import { qrSetFrames } from "../../../../../redux/slices/qrFrames";
import { qrSetSettings } from "../../../../../redux/slices/qrSettings";
import { qrSetText } from "../../../../../redux/slices/qrTextSettings";
import { setQrOptions } from "../../../../../redux/slices/qrOptions";

const PreMadeFrames = () => {
  const lang = useSelector((state) => state.changeLang.language.modalFrames);
  const langFrame = useSelector(
    (state) => state.changeLang.language.stepThree.frame
  );
  const preTempates = useSelector(
    (state) => state.preMadeTemplates.preTempates
  );

  const { isDesktop } = useWindowSize();
  const dispatch = useDispatch();

  const countMore = isDesktop
    ? preTempates.length > 14
      ? preTempates.length - 14
      : 0
    : preTempates.length > 6
    ? preTempates.length - 6
    : 0;

  const handleViewMore = () => {
    dispatch(setFramesModalCategory("preMade"));
    dispatch(setIsFramesModal(true));
  };

  const handleTemplateBtn = (template) => {
    dispatch(setActivePremadeTemplateId(template.id));
    dispatch(qrSetFrames(template.qrFrames));
    dispatch(qrSetSettings(template.qrSettings));
    dispatch(
      qrSetText({
        ...template.qrText,
        textSize: template.qrText.textSize || -1,
      })
    );
    dispatch(setQrOptions(template.qrOptions));
  };

  if (!preTempates.length) {
    return null;
  }

  return (
    <section
      className="bg-white p-3 p-md-4 mt-3 mbt-lg-4 text-capitalize rounded-1"
      id="premadeFrames"
    >
      <Row className="d-flex justify-content-between alignt-itens-center mb-3 mb-md-4 flex-nowrap">
        <Col xs={7} md="auto">
          <div className="fw-bold fs-4">{lang[37]}</div>
        </Col>
        <Col xs={5} md={2}>
          <div
            className="text-white fw-bold w-100 btn btn-primary fs-7"
            onClick={() => handleViewMore()}
          >
            {langFrame[10]}
          </div>
        </Col>
      </Row>

      <Row className="g-cards mb-3">
        <NoTemplateBtn />
        {preTempates.slice(0, isDesktop ? 14 : 6).map((template) => (
          <CustomCol xs={3} key={template.id}>
            <PreMadeFrameItem
              template={template}
              handleTemplateBtn={handleTemplateBtn}
            />
          </CustomCol>
        ))}
        {countMore > 0 && (
          <CustomCol>
            <FrameItem
              className="d-flex justify-content-center align-items-center border rounded-1 p-2 h-100 flex-column fs-4 cursor-pointer"
              onClick={handleViewMore}
            >
              +{countMore}
            </FrameItem>
          </CustomCol>
        )}
      </Row>
    </section>
  );
};

export default memo(PreMadeFrames);
